import { Trade, OrderType } from './types';

const isSplit = (trade: Trade) => {
  return trade.orderType === OrderType.Split;
};

export default isSplit;
